import { Rule } from '../rule'
import { uuid } from '../uuid'
import { DataOptions, ArrayDataOptions, DependOnOption, DisabledType } from '../common'

export class SelectDef {
  key?: string = uuid()
  type: 'select' = 'select'
  model!: string
  label!: string
  dependOn?: DependOnOption
  options?: SelectOptions = new SelectOptions()
  rules?: Rule[]
}

export class SelectOptions {
  multiple?: boolean = false
  defaultValue?: string | string[]
  disabled?: DisabledType = false
  placeholder?: string
  labelWidth?: string | number
  required?: boolean = false
  clearable?: boolean = true
  options?: DataOptions = {}
  filterable?: boolean
  remote?: boolean
  remoteMethod?: (q: string, cb: (ret: ArrayDataOptions) => void) => void
  onChange?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any>; items: ArrayDataOptions }) => void
  onValueChange?: (options: { value: any; form: Record<string, any>; rowForm: Record<string, any>; items: ArrayDataOptions }) => void
}
